export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20amber%20gradient%20flowing%20texture%20with%20soft%20geometric%20shapes%2C%20modern%20smooth%20design%2C%20warm%20lighting%20effect%20from%20center%2C%20minimalist%20tech%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20clean%20composition%20with%20organic%20curves&width=1800&height=700&seq=cta-bg-ky-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-900/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading text-white mb-4">
            准备好开始了吗？
          </h2>
          <p className="text-sm md:text-base text-white/70 mb-8 leading-relaxed">
            立即访问 www.ky.app 下载 KY App，开启全新移动体验。安全、稳定、流畅，尽在官方渠道。
          </p>
          <a
            href="#download"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-primary-600 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all duration-200 hover:scale-105"
          >
            <i className="ri-download-2-line text-lg"></i>
            立即下载 KY App
          </a>
        </div>
      </div>
    </section>
  );
}